import { fetchApi } from '@/config/axiosSetting';
import { patchVisitInformationParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitInformation/patchVisitInformationQuery.type';

export const patchVisitInformation = (params: patchVisitInformationParams) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/visit_information/`,
    {
      ...params?.data,
    },
    {
      params: {
        id: params?.id,
        damaged_id: params?.damaged_id,
        source: 'pwa',
      },
    },
  );
};
